import IssueGenericLoading from './IssueGenericLoading';

/**
 * Displays the loading state for a quality issue.
 */
const QualityIssueLoading = () => {
  return (
    <IssueGenericLoading>
      {(contentStartY) => {
        return (
          <>
            {/* Issue Details */}
            <rect x="0" y={contentStartY + 70} rx="3" ry="3" width="95%" height="140" />
            {/* Dependency */}
            <rect x="0" y={contentStartY + 220} rx="3" ry="3" width="95%" height="200" />
          </>
        );
      }}
    </IssueGenericLoading>
  );
};

export default QualityIssueLoading;
